var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgApps = function SvgApps(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.75,
    d: "M15 20h5v-5h-5zm0-7.5h5v-5h-5zM7.5 5h5V0h-5zM15 5h5V0h-5zm-7.5 7.5h5v-5h-5zm-7.5 0h5v-5H0zM0 20h5v-5H0zm7.5 0h5v-5h-5zM0 5h5V0H0z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgApps);
export { ForwardRef as ReactComponent };